export default class CommonJsStorage {
    protected store: Object;

    public constructor(store: Object) {
        this.store = store;
    }

    /**
     * Вернет null если key не существует
     */
    public get(key: string): any {
        return typeof (this.store[key]) === 'undefined' ? null : this.store[key];
    }

    public set(key: string, value: any) {
        this.store[key] = value;
    }
}
